function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M228 128a100 100 0 10-167.29 73.91 3.97 3.97 0 00.842.75 99.794 99.794 0 00132.898-.001 3.966 3.966 0 00.838-.748A99.763 99.763 0 00228 128zm-192 0a92 92 0 11157.171 64.872 75.616 75.616 0 00-44.507-34.04 44 44 0 10-41.328 0 75.618 75.618 0 00-44.507 34.04A91.708 91.708 0 0136 128zm92 28a36 36 0 1136-36 36.04 36.04 0 01-36 36zm-59.135 42.417a68.01 68.01 0 01118.27 0 91.804 91.804 0 01-118.27 0z"
});

function SvgUserCircleThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgUserCircleThin;